import { useEffect, useState } from "react";
import { api } from "../api/client";
import { useToast, errText, JsonArea } from "../components/ui";

const DEFAULTS: Record<string, Record<string, unknown>> = {
  risk: { enabled: false, max_total_exposure: null, max_symbol_net: null, max_daily_realized_loss: null },
  reconcile: { enabled: false, interval: 60, auto_correct: false },
};

export default function Settings({ onChanged }: { onChanged: () => void }) {
  const notify = useToast();
  const [values, setValues] = useState<Record<string, Record<string, unknown>>>(DEFAULTS);

  const load = async () => {
    try {
      const list = await api.listSettings();
      const merged = { ...DEFAULTS };
      for (const s of list) merged[s.key] = s.value;
      setValues(merged);
    } catch (e) { notify({ kind: "error", msg: errText(e) }); }
  };
  useEffect(() => { load(); }, []);

  const save = async (key: string) => {
    try { await api.upsertSetting(key, values[key]); onChanged(); notify({ kind: "ok", msg: `已保存设置: ${key}` }); }
    catch (e) { notify({ kind: "error", msg: errText(e) }); }
  };

  return (
    <div>
      <div className="panel">
        <div className="card-head"><span className="title">组合风控闸门 risk</span></div>
        <p className="muted" style={{ fontSize: 12 }}>仅同步引擎生效；只拦截"增加敞口"的单，平仓永远放行。限额为 null 表示不限。</p>
        <JsonArea value={values.risk} onChange={(v) => setValues({ ...values, risk: v })} rows={5} />
        <div style={{ marginTop: 8 }}><button onClick={() => save("risk")}>保存草稿</button></div>
      </div>
      <div className="panel">
        <div className="card-head"><span className="title">仓位对账 reconcile</span></div>
        <p className="muted" style={{ fontSize: 12 }}>定期与券商实际持仓比对，发现漂移告警；auto_correct=true 时校正内存仓位。</p>
        <JsonArea value={values.reconcile} onChange={(v) => setValues({ ...values, reconcile: v })} rows={4} />
        <div style={{ marginTop: 8 }}><button onClick={() => save("reconcile")}>保存草稿</button></div>
      </div>
    </div>
  );
}
